import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNearRealTimeMonitoring = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.8913 11.0667L13.3656 12.4181C11.8966 14.0198 11 16.155 11 18.4997C11 20.8443 11.8966 22.9795 13.3656 24.5812L11.8913 25.9327C10.0958 23.9751 9 21.3653 9 18.4997C9 15.634 10.0958 13.0243 11.8913 11.0667ZM28.1087 11.067C29.9042 13.0246 31 15.6343 31 18.5C31 21.3657 29.9042 23.9754 28.1087 25.933L26.6344 24.5816C28.1034 22.9799 29 20.8446 29 18.5C29 16.1554 28.1034 14.0201 26.6344 12.4184L28.1087 11.067ZM16.7208 30.5L17.3874 28.5H22.6126L23.2792 30.5H25.3874L22.1012 20.6413C22.6559 20.0969 23 19.3386 23 18.5C23 16.8431 21.6569 15.5 20 15.5C18.3431 15.5 17 16.8431 17 18.5C17 19.3386 17.3441 20.0969 17.8988 20.6413L14.6126 30.5H16.7208ZM18.0541 26.5L18.7208 24.5H21.2792L21.9459 26.5H18.0541ZM20.6126 22.5L20.2751 21.4875C20.1845 21.4958 20.0927 21.5 20 21.5C19.9073 21.5 19.8155 21.4958 19.7249 21.4875L19.3874 22.5H20.6126ZM21 18.5C21 19.0523 20.5523 19.5 20 19.5C19.4477 19.5 19 19.0523 19 18.5C19 17.9477 19.4477 17.5 20 17.5C20.5523 17.5 21 17.9477 21 18.5ZM27 18.5C27 16.6764 26.3027 15.0157 25.1601 13.7699L23.6858 15.1214C24.5019 16.0112 25 17.1974 25 18.5C25 19.8026 24.5019 20.9888 23.6858 21.8786L25.1601 23.2301C26.3027 21.9843 27 20.3236 27 18.5ZM16.3142 15.121L14.8399 13.7696C13.6973 15.0153 13 16.6761 13 18.4997C13 20.3233 13.6973 21.984 14.8399 23.2298L16.3142 21.8783C15.4981 20.9885 15 19.8022 15 18.4997C15 17.1971 15.4981 16.0108 16.3142 15.121Z",
		fill: "#00B087"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1.5,
		width: 38,
		height: 38,
		rx: 15,
		stroke: "#00B087",
		strokeWidth: 2
	})]
});
export default SvgNearRealTimeMonitoring;
